import Table from '~/components/Table';
import {useEffect, useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckDouble, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";
import NotificationsApi from '~/api/notificationsApi';

function NotificationTab({title}){
    const tableConfig = {
        columns: [
            {
                name: 'EVENT NAME',
                width: '150px',
                key: 'EventName',
                className: "fw-bold",
            },
            {
                name: 'CONTENT',
                width: '300px',
                key: 'Content',
            },
            {
                name: 'CREATED AT',
                width: '200px',
                template: (row) => {
                    return (
                        format(new Date(row.CreatedAt), "dd/MM/yyyy hh:mm:ss")
                    )
                }
            },
            {
                name: 'IS READ',
                width: '70px',
                template: (row) => {
                   return (row.IsRead ? <FontAwesomeIcon icon={faCheckDouble} style={{color: 'green'}} /> : "");
                }
            },
            {
                name: 'READ AT',
                width: '150px',
                template: (row) => {
                    return (
                        row.ReadAt ? format(new Date(row.ReadAt), "dd/MM/yyyy hh:mm:ss") : ""
                    )
                }
            },
            {
                name: 'MARK READ',
                width: '100px',
                template: (row) => {
                    return (!row.IsRead ? <FontAwesomeIcon className="cursor-pointer" icon={faCheckCircle} style={{color: 'green'}} /> : "");
                }
            }
        ],
        data : []
    }

    const [notifications, setNotifications] = useState([]);
    useEffect(function(){
        NotificationsApi.getByUserId(2)
            .then((res) => {
                setNotifications(res.data);
            })
            .catch((err) => {
                ;
            });
    }, [])


    return (
        <div className="mb-6">
            <h4 className="mb-4 text-center">{title}</h4>
            <Table tableConfig={{...tableConfig, data: notifications}} />
            <div className="text-center mb-6 mt-4">
                <button className="btn btn-bt-secondary">Mark All As Read</button>
            </div>
        </div>
    )
}

export default NotificationTab;